import { adjustmentSessionIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";

export const submitAdjustmentSession = {
  name: "submitAdjustmentSession" as const,
  input: z.object({ sessionId: adjustmentSessionIdFormat.schema }),
  output: z.object({ success: z.boolean() }),
};
